(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidQuestionDeleteController',CovidQuestionDeleteController);

    CovidQuestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidQuestion'];

    function CovidQuestionDeleteController($uibModalInstance, entity, CovidQuestion) {
        var vm = this;

        vm.covidQuestion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidQuestion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
